import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { StaffRoleFragmentDoc } from './StaffRole';
import { StaffRoleProfileFragmentDoc } from './StaffRoleProfile';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
export type StaffRoleWithRoleProfileFragment = { id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, roleProfile: { usersCount: number, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> }, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null };


export type StaffRoleWithRoleProfileFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const StaffRoleWithRoleProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment StaffRoleWithRoleProfile on RoleType {
  ...StaffRole
  roleProfile {
    ...StaffRoleProfile
  }
}
    `;